import React, { Component } from "react";
import "./Footer.scss"

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div id="footer">
          <div className="padding">
            <div className="policy">
              <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">תנאי שימוש</a> | <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">מדיניות פרטיות</a>
            </div>
            <a href="//www.yit.co.il/" title="YIT" target="_blank" rel="noopener noreferrer">
              <div className="yitlogo"></div>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx